import { GitView } from "../../../../features/GitView";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const gitViewRouteConfig: AppRouteProps = {
  path: appRouterPaths.gitfolders.root,
  element: <GitView />,
  name: "Общее пространство",
};
